import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../../Store';
import ModuleGameboySettings, { Props } from '../_components/ModuleGameboySettings';
import { ModuleOnValueUpdate } from '../../_actions/ModuleActions';

const mapStateToProps = (store:Store, props:Props) => ({});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModuleGameboySettings);